import { Injectable } from '@angular/core'

declare const window: any

interface AmplitudeUserData {
  id?: string
  pkey?: string
  firstname: string
  lastname: string
  email?: string
  primaryemail?: string
  phone?: string
  created?: number
  account?: number
}

function amplitudeInstance() {
  // NOTE: there is no window during the prerendering build step. Don't let it crash
  if (typeof window === 'undefined') return
  return window.amplitude?.getInstance()
}

@Injectable({
  providedIn: 'root',
})
export class AmplitudeService {
  initialized = false
  constructor() { }

  init(apiKey: string): void {
    if (apiKey) {
      this.initialized = true
      amplitudeInstance()?.init(apiKey)
    } else {
      console.log(`init`)
    }
  }

  logEvent(event: string): void {
    if (this.initialized === true) {
      amplitudeInstance()?.logEvent(event)
    } else {
      console.log(`event - ${event}`)
    }
  }

  logPageView(): void {
    if (this.initialized === true) {
      amplitudeInstance()?.logEvent('pageview', { url: window.location.pathname })
    } else {
      console.log(`view - ${window.location.pathname}`)
    }
  }

  setUser(user: AmplitudeUserData, customAttributes: any = {}): void {
    if (this.initialized !== true || !user) {
      return
    }

    const userId = user.id || user.pkey;
    amplitudeInstance()?.setUserId(userId)

    const payload = {
      user_id: userId,
      user_email: user.primaryemail || user.email,
      user_name: `${user.firstname} ${user.lastname}`,
      user_phone: user.phone,
      user_created_at: user.created,
      account: user.account,
      ...customAttributes,
    }

    try {
      const identify = new window.amplitude.Identify()

      Object.keys(payload).forEach((key) => {
        identify.set(key, payload[key])
      })

      amplitudeInstance()?.identify(identify)
    } catch (e) {
      console.log('error logging to amplitude')
    }
  }

  logOut(): void {
    if (this.initialized !== true) {
      return
    }

    amplitudeInstance()?.setUserId(null)
  }
}
